var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 38C29.7173 38 38 29.7173 38 19.5C38 9.28273 29.7173 1 19.5 1C9.28273 1 1 9.28273 1 19.5C1 29.7173 9.28273 38 19.5 38Z",
    fill: "white",
    stroke: "#3D8EE8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4924 16.9613C22.0187 16.9613 24.0667 14.9132 24.0667 12.3869C24.0667 9.86052 22.0187 7.8125 19.4924 7.8125C16.966 7.8125 14.918 9.86052 14.918 12.3869C14.918 14.9132 16.966 16.9613 19.4924 16.9613Z",
    fill: "#3D8EE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9838 26.5495C27.9838 28.2592 27.4795 29.8528 26.6077 31.1839H12.3878C11.516 29.8528 11.0117 28.2592 11.0117 26.5495C11.0117 21.8626 14.8118 18.0625 19.4987 18.0625C24.1856 18.0625 27.9857 21.8607 27.9857 26.5495H27.9838Z",
    fill: "#3D8EE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.5803bab17f5ea6488e67dcd02c4f7dc4.svg";
export { ForwardRef as ReactComponent };